export const spring = { mass: 3, tension: 5000, friction: 200 }
